<div class="tpl3pl-page-container">
	<div class="tpl3pl-stat-cards-wrap mb-3">
		<div *ngIf="statsLoading && !queueStats" class="tpl3pl-stat-cards-loading">
			<mat-spinner diameter="36"></mat-spinner>
			<span class="text-muted small ml-2">Loading queue summary…</span>
		</div>
		<div class="tpl3pl-stat-cards" *ngIf="queueStats as s">
			<mat-card class="tpl3pl-stat-card">
				<div class="tpl3pl-stat-value">{{ s.total_active }}</div>
				<div class="tpl3pl-stat-label">Active in queue</div>
				<div class="tpl3pl-stat-sublabel">Not archived</div>
			</mat-card>
			<mat-card class="tpl3pl-stat-card tpl3pl-stat-card--accent">
				<div class="tpl3pl-stat-value">{{ s.actionable }}</div>
				<div class="tpl3pl-stat-label">Ready to run</div>
				<div class="tpl3pl-stat-sublabel">Pending + failed</div>
			</mat-card>
			<mat-card class="tpl3pl-stat-card">
				<div class="tpl3pl-stat-value">{{ s.pending }}</div>
				<div class="tpl3pl-stat-label">Pending</div>
			</mat-card>
			<mat-card class="tpl3pl-stat-card">
				<div class="tpl3pl-stat-value">{{ s.exporting }}</div>
				<div class="tpl3pl-stat-label">Exporting</div>
			</mat-card>
			<mat-card class="tpl3pl-stat-card tpl3pl-stat-card--warn">
				<div class="tpl3pl-stat-value">{{ s.failed }}</div>
				<div class="tpl3pl-stat-label">Failed</div>
			</mat-card>
			<mat-card class="tpl3pl-stat-card">
				<div class="tpl3pl-stat-value">{{ s.dead_letter }}</div>
				<div class="tpl3pl-stat-label">Dead letter</div>
			</mat-card>
			<mat-card class="tpl3pl-stat-card tpl3pl-stat-card--ok">
				<div class="tpl3pl-stat-value">{{ s.exported }}</div>
				<div class="tpl3pl-stat-label">Exported</div>
				<div class="tpl3pl-stat-sublabel">In list</div>
			</mat-card>
			<mat-card class="tpl3pl-stat-card tpl3pl-stat-card--partial">
				<div class="tpl3pl-stat-value">{{ s.exported_not_shipped ?? 0 }}</div>
				<div class="tpl3pl-stat-label">Exported, not shipped</div>
				<div class="tpl3pl-stat-sublabel">No shipment confirm yet</div>
			</mat-card>
			<mat-card class="tpl3pl-stat-card tpl3pl-stat-card--muted">
				<div class="tpl3pl-stat-value">{{ s.archived_exported }}</div>
				<div class="tpl3pl-stat-label">Archived</div>
				<div class="tpl3pl-stat-sublabel">Exported, hidden</div>
			</mat-card>
		</div>
		<div class="tpl3pl-stat-subrow" *ngIf="queueStats?.open_queue_fillability as fq">
			<div class="tpl3pl-stat-subrow-head">
				<span class="tpl3pl-stat-subrow-title">Open queue fillability</span>
				<span class="tpl3pl-stat-subrow-meta text-muted">Pending / exporting / failed / dead letter · {{ fq.open_queue_orders }} orders (max 5000 scanned)</span>
			</div>
			<div class="tpl3pl-stat-cards">
				<mat-card class="tpl3pl-stat-card tpl3pl-stat-card--ok">
					<div class="tpl3pl-stat-value">{{ fq.fillable }}</div>
					<div class="tpl3pl-stat-label">Fillable</div>
					<div class="tpl3pl-stat-sublabel">Stock covers open lines</div>
				</mat-card>
				<mat-card class="tpl3pl-stat-card tpl3pl-stat-card--partial">
					<div class="tpl3pl-stat-value">{{ fq.partial }}</div>
					<div class="tpl3pl-stat-label">Partial</div>
					<div class="tpl3pl-stat-sublabel">Some lines short</div>
				</mat-card>
				<mat-card class="tpl3pl-stat-card tpl3pl-stat-card--unfill">
					<div class="tpl3pl-stat-value">{{ fq.not_fillable }}</div>
					<div class="tpl3pl-stat-label">Not fillable</div>
					<div class="tpl3pl-stat-sublabel">All stock lines short</div>
				</mat-card>
				<mat-card class="tpl3pl-stat-card">
					<div class="tpl3pl-stat-value">{{ fq.unknown }}</div>
					<div class="tpl3pl-stat-label">Unknown</div>
					<div class="tpl3pl-stat-sublabel">No open lines / ERP</div>
				</mat-card>
			</div>
		</div>
	</div>
	<div class="tpl3pl-toolbar tpl3pl-export-queue-toolbar">
		<div class="tpl3pl-toolbar-filters tpl3pl-toolbar-filters--full">
			<div class="tpl3pl-filter-panel">
				<div class="tpl3pl-filter-panel__section">
					<div class="tpl3pl-filter-panel__head">
						<span class="tpl3pl-filter-panel__title">Status &amp; fillability</span>
						<span class="tpl3pl-filter-panel__meta">Changes reload the list (short debounce)</span>
					</div>
					<div class="tpl3pl-filter-panel__grid tpl3pl-filter-panel__grid--4">
						<mat-form-field appearance="fill" class="tpl3pl-field tpl3pl-field--fill">
							<mat-label>Export status</mat-label>
							<mat-select multiple [(ngModel)]="exportStatusFilters" (selectionChange)="onServerQueueFiltersChange()">
								<mat-option *ngFor="let o of exportStatusOptions" [value]="o.value">{{ o.label }}</mat-option>
							</mat-select>
						</mat-form-field>
						<mat-form-field appearance="fill" class="tpl3pl-field tpl3pl-field--fill">
							<mat-label>Queue state</mat-label>
							<mat-select multiple [(ngModel)]="queueStateFilters" (selectionChange)="onServerQueueFiltersChange()">
								<mat-option *ngFor="let o of queueStateOptions" [value]="o.value">{{ o.label }}</mat-option>
							</mat-select>
						</mat-form-field>
						<mat-form-field appearance="fill" class="tpl3pl-field tpl3pl-field--fill">
							<mat-label>ERP order status</mat-label>
							<mat-select multiple [(ngModel)]="erpStatusFilters" (selectionChange)="onServerQueueFiltersChange()">
								<mat-option *ngFor="let s of orderStatusesForSelect" [value]="+s.order_status_id">{{ s.name }} ({{ s.order_status_id }})</mat-option>
							</mat-select>
						</mat-form-field>
						<mat-form-field appearance="fill" class="tpl3pl-field tpl3pl-field--fill">
							<mat-label>Fillability</mat-label>
							<mat-select multiple [(ngModel)]="fillabilityFilters" (selectionChange)="onFillabilityFilterChange()">
								<mat-option *ngFor="let o of fillabilityOptions" [value]="o.value">{{ o.label }}</mat-option>
							</mat-select>
							<mat-hint>Server-side; combine with status filters</mat-hint>
						</mat-form-field>
					</div>
				</div>

				<div class="tpl3pl-filter-panel__section">
					<div class="tpl3pl-filter-panel__head">
						<span class="tpl3pl-filter-panel__title">Text search</span>
						<span class="tpl3pl-filter-panel__meta">Enter or Apply to run</span>
					</div>
					<div class="tpl3pl-filter-panel__grid tpl3pl-filter-panel__grid--4">
						<mat-form-field appearance="fill" class="tpl3pl-field tpl3pl-field--fill">
							<mat-label>Order # (exact)</mat-label>
							<input
								matInput
								[(ngModel)]="orderFilter"
								(keyup.enter)="applyQueueFilters()"
								placeholder="Exact order number">
							<span matSuffix>
								<button mat-icon-button type="button" (click)="applyQueueFilters()" matTooltip="Apply search">
									<mat-icon>search</mat-icon>
								</button>
							</span>
						</mat-form-field>
						<mat-form-field appearance="fill" class="tpl3pl-field tpl3pl-field--fill">
							<mat-label>Order contains</mat-label>
							<input matInput [(ngModel)]="orderContainsFilter" (keyup.enter)="applyQueueFilters()" placeholder="Substring on order #">
						</mat-form-field>
						<mat-form-field appearance="fill" class="tpl3pl-field tpl3pl-field--fill">
							<mat-label>3PL order ID contains</mat-label>
							<input matInput [(ngModel)]="pgsIdContains" (keyup.enter)="applyQueueFilters()" placeholder="PGS / remote id">
						</mat-form-field>
						<mat-form-field appearance="fill" class="tpl3pl-field tpl3pl-field--fill">
							<mat-label>Error contains</mat-label>
							<input matInput [(ngModel)]="errorContains" (keyup.enter)="applyQueueFilters()" placeholder="Error message text">
						</mat-form-field>
					</div>
				</div>

				<div class="tpl3pl-filter-panel__footer">
					<div class="tpl3pl-filter-panel__footer-primary">
						<button
							mat-stroked-button
							type="button"
							(click)="applyNotExportedFillablePreset()"
							[disabled]="loading"
							matTooltip="Pending / failed / exporting / dead letter + fillable only">
							<mat-icon>bolt</mat-icon>
							<span class="ml-1">Not exported + fillable</span>
						</button>
						<button
							mat-raised-button
							color="primary"
							type="button"
							(click)="applyQueueFilters()"
							[disabled]="loading"
							matTooltip="Reload queue with current filters">
							<mat-icon>filter_list</mat-icon>
							<span class="ml-1">Apply</span>
						</button>
						<button
							mat-stroked-button
							type="button"
							(click)="clearFiltersAndReload()"
							[disabled]="loading"
							matTooltip="Reset all filters and reload">
							<mat-icon>clear_all</mat-icon>
							<span class="ml-1">Clear all</span>
						</button>
						<mat-checkbox [(ngModel)]="includeArchived" (ngModelChange)="loadQueue()" class="tpl3pl-toolbar-checkbox">Include archived</mat-checkbox>
					</div>
					<div class="tpl3pl-filter-panel__footer-secondary">
						<button
							mat-stroked-button
							type="button"
							color="accent"
							(click)="forceResendByOrderField()"
							[disabled]="loading || processing || rawPushInProgress || !(orderFilter || '').trim() || !!exportingOrderNo"
							matTooltip="Re-send to 3PL after the warehouse removed the order; uses exact order # above; bypasses shipped and duplicate guards for this attempt">
							<mat-icon>published_with_changes</mat-icon>
							<span class="ml-1">Force re-send</span>
						</button>
						<div class="tpl3pl-filter-panel__summary" *ngIf="!loading && queueTotal != null">
							<span class="text-muted small tpl3pl-queue-cap">
								<span *ngIf="fillabilityFilters.length === 0">Up to 100 rows</span>
								<span *ngIf="fillabilityFilters.length > 0">Up to 500 fillability matches</span>
							</span>
							<span class="text-muted small tpl3pl-queue-total">· {{ queueTotal }} match<span *ngIf="queueTotal !== 1">es</span></span>
							<span class="text-warning small" *ngIf="fillabilityScanCapped">· Scan capped — narrow filters</span>
						</div>
					</div>
				</div>
				<p class="small text-muted mb-0 tpl3pl-filter-help">Dropdowns and fillability reload automatically. Text search applies when you click Apply or press Enter in a field.</p>
			</div>
		</div>
		<div class="tpl3pl-toolbar-actions tpl3pl-export-queue-toolbar-actions">
			<button
				mat-stroked-button
				(click)="refreshQueue()"
				[disabled]="loading"
				matTooltip="Reload queue">
				<mat-spinner *ngIf="loading" diameter="20" class="d-inline-block mr-1"></mat-spinner>
				<mat-icon *ngIf="!loading">refresh</mat-icon>
				<span class="ml-1">{{ loading ? 'Loading…' : 'Refresh' }}</span>
			</button>
			<button
				mat-raised-button
				color="primary"
				(click)="processQueue()"
				[disabled]="processing || loading || rawPushInProgress || batchDeleting || !dataSource?.data?.length"
				matTooltip="Process pending orders in the queue">
				<mat-spinner *ngIf="processing" diameter="20" class="d-inline-block mr-1"></mat-spinner>
				<mat-icon *ngIf="!processing">play_arrow</mat-icon>
				<span class="ml-1">{{ processing ? 'Processing…' : 'Process Queue' }}</span>
			</button>
			<ng-container *ngIf="removableOrdersCount > 0">
				<button
					mat-raised-button
					color="accent"
					type="button"
					class="mr-2"
					(click)="exportSelectedBatch()"
					[disabled]="loading || rawPushInProgress || processing || batchDeleting || selectedBatchEligibleCount === 0 || !!exportingOrderNo"
					matTooltip="Export every checked pending or failed order, one at a time (same as raw manual push)">
					<mat-icon>playlist_add_check</mat-icon>
					<span class="ml-1">Export selected ({{ selectedBatchEligibleCount }})</span>
				</button>
				<button
					mat-stroked-button
					color="warn"
					type="button"
					class="mr-2"
					(click)="removeSelectedFromQueue()"
					[disabled]="loading || rawPushInProgress || processing || batchDeleting || selectedRemovableCount === 0 || !!exportingOrderNo"
					matTooltip="Remove checked pending, failed, or dead-letter rows from the queue (same as row trash)">
					<mat-spinner *ngIf="batchDeleting" diameter="20" class="d-inline-block mr-1"></mat-spinner>
					<mat-icon *ngIf="!batchDeleting">delete_outline</mat-icon>
					<span class="ml-1">{{ batchDeleting ? 'Removing…' : ('Remove selected (' + selectedRemovableCount + ')') }}</span>
				</button>
				<button
					mat-stroked-button
					type="button"
					class="mr-2"
					(click)="clearBatchSelection()"
					[disabled]="loading || rawPushInProgress || batchDeleting || !selection.hasValue()"
					matTooltip="Clear all row checkboxes">
					<mat-icon>check_box_outline_blank</mat-icon>
					<span class="ml-1">Clear selection</span>
				</button>
				<mat-form-field appearance="fill" class="tpl3pl-field mr-2 raw-push-limit">
					<mat-label>Batch size</mat-label>
					<mat-select [(ngModel)]="rawPushLimit" (ngModelChange)="onRawPushLimitChange()">
						<mat-option [value]="5">5</mat-option>
						<mat-option [value]="10">10</mat-option>
						<mat-option [value]="20">20</mat-option>
					</mat-select>
				</mat-form-field>
				<button
					mat-stroked-button
					(click)="rawManualPush()"
					[disabled]="loading || rawPushInProgress || batchDeleting || eligibleOrdersCount === 0"
					matTooltip="Push this many pending/failed orders one at a time and see each API response">
					<mat-spinner *ngIf="rawPushInProgress" diameter="20" class="d-inline-block mr-1"></mat-spinner>
					<mat-icon *ngIf="!rawPushInProgress">code</mat-icon>
					<span class="ml-1">{{ rawPushInProgress ? ('Pushing ' + rawPushProgress + '…') : 'Raw manual push' }}</span>
				</button>
			</ng-container>
		<button
			mat-stroked-button
			(click)="archiveAllExported()"
			class="mr-2"
			[disabled]="loading || processing || rawPushInProgress || batchDeleting"
			matTooltip="Archive all exported orders (hide from default list)">
			<mat-icon>archive</mat-icon>
			<span class="ml-1">Archive Exported</span>
		</button>
		<mat-form-field appearance="fill" class="tpl3pl-field mr-2 raw-push-limit">
			<mat-label>PGS poll batch</mat-label>
			<mat-select [(ngModel)]="pgsMassBatchSize">
				<mat-option [value]="5">5</mat-option>
				<mat-option [value]="10">10</mat-option>
				<mat-option [value]="25">25</mat-option>
				<mat-option [value]="50">50</mat-option>
			</mat-select>
		</mat-form-field>
		<button
			mat-stroked-button
			(click)="massUpdatePgsStatus()"
			class="mr-2"
			[disabled]="loading || processing || rawPushInProgress || batchDeleting || massStatusUpdating"
			matTooltip="Poll PGS in small HTTP batches (each order still queried individually); DB updates after each order. Larger batch = more orders per request.">
			<mat-spinner *ngIf="massStatusUpdating" diameter="20" class="d-inline-block mr-1"></mat-spinner>
			<mat-icon *ngIf="!massStatusUpdating">sync</mat-icon>
			<span class="ml-1">{{ massStatusUpdating ? 'Refreshing…' : 'Refresh PGS Status' }}</span>
		</button>
	</div>
</div>

	<div *ngIf="massStatusUpdating" class="mt-2 small text-muted">
		{{ massStatusProgress || 'Polling PGS in batches (one order per PGS call per batch request)…' }}
	</div>
	<div *ngIf="massStatusResult" class="mt-2 alert" [ngClass]="massStatusResult.failed > 0 ? 'alert-warning' : 'alert-success'" style="font-size:0.85rem; padding: 8px 12px;">
		<strong>PGS Status Refresh:</strong>
		<span *ngIf="massStatusResult.batch_count" class="text-muted">&nbsp;({{ massStatusResult.batch_count }} HTTP batch(es))&nbsp;</span>
		{{ massStatusResult.checked }} checked &nbsp;·&nbsp;
		<span class="text-success">{{ massStatusResult.updated }} queue state(s) updated</span> &nbsp;·&nbsp;
		<span *ngIf="massStatusResult.erp_status_updated" class="text-info">{{ massStatusResult.erp_status_updated }} ERP status(es) updated</span>
		<span *ngIf="massStatusResult.erp_status_updated">&nbsp;·&nbsp;</span>
		{{ massStatusResult.unchanged }} unchanged &nbsp;·&nbsp;
		<span *ngIf="massStatusResult.failed > 0" class="text-danger">{{ massStatusResult.failed }} failed</span>
		<button mat-icon-button style="float:right; margin-top:-4px;" (click)="massStatusResult = null"><mat-icon>close</mat-icon></button>
		<div *ngIf="massStatusResult.failed > 0 || massStatusResult.updated > 0 || (massStatusResult.erp_status_updated && massStatusResult.erp_status_updated > 0)" class="mt-1" style="max-height:160px; overflow-y:auto;">
			<div *ngFor="let d of massStatusResult.details" class="small">
				<ng-container *ngIf="d.status === 'updated' || d.status === 'error'">
					<span [ngClass]="d.status === 'error' ? 'text-danger' : 'text-success'">
						{{ d.orderno }}
					</span>
					<span class="text-muted ml-1">
						{{ d.status === 'error' ? d.message : (d.old_state + ' → ' + d.new_state + ' (' + d.pgs_status + ')') }}
					</span>
				</ng-container>
				<ng-container *ngIf="d.old_erp_status_id != null && d.new_erp_status_id != null && d.new_erp_status_id !== d.old_erp_status_id">
					<div class="ml-2 text-info">
						{{ d.orderno }} — ERP {{ d.old_erp_status_id }} → {{ d.new_erp_status_id }}
					</div>
				</ng-container>
			</div>
		</div>
	</div>

	<div *ngIf="rawPushInProgress && rawPushProgress" class="mt-2 small text-muted">
		Pushing order ({{ rawPushProgress }})…
	</div>

	<div *ngIf="rawPushResults.length > 0" class="mt-3 raw-push-results-panel">
		<div class="d-flex justify-content-between align-items-center mb-2">
			<strong>Export batch — review failures ({{ rawPushResults.length }} orders)</strong>
			<button mat-stroked-button type="button" (click)="dismissRawPushResults()">Dismiss</button>
		</div>
		<p class="small text-muted mb-2">Shown only when something failed. Use the code icon per row for the API payload. All-success batches only show the toast.</p>
		<table mat-table [dataSource]="rawPushResultsDataSource" class="w-100 compact-table">
			<ng-container matColumnDef="orderno">
				<th mat-header-cell *matHeaderCellDef>Order</th>
				<td mat-cell *matCellDef="let row">{{ row.orderno }}</td>
			</ng-container>
			<ng-container matColumnDef="status">
				<th mat-header-cell *matHeaderCellDef>Status</th>
				<td mat-cell *matCellDef="let row">
					<span [class.badge-success]="row.success" [class.badge-danger]="!row.success" class="badge">{{ row.success ? 'Success' : 'Failed' }}</span>
				</td>
			</ng-container>
			<ng-container matColumnDef="message">
				<th mat-header-cell *matHeaderCellDef>Message</th>
				<td mat-cell *matCellDef="let row" class="message-cell">{{ row.message || '–' }}</td>
			</ng-container>
			<ng-container matColumnDef="view_raw">
				<th mat-header-cell *matHeaderCellDef></th>
				<td mat-cell *matCellDef="let row">
					<button mat-icon-button color="accent" (click)="openRawResponseForResult(row)" matTooltip="View raw response">
						<mat-icon>code</mat-icon>
					</button>
				</td>
			</ng-container>
			<tr mat-header-row *matHeaderRowDef="rawPushResultsColumns"></tr>
			<tr mat-row *matRowDef="let r; columns: rawPushResultsColumns;"></tr>
		</table>
	</div>

	<div *ngIf="lastExportResult && lastExportResult.success" class="mt-3 result-banner">
		<div class="alert alert-success d-flex justify-content-between align-items-center">
			<div><strong>Export:</strong> {{ lastExportResult.message }}</div>
			<button type="button" class="close" aria-label="Close" (click)="dismissLastResult()">
				<span aria-hidden="true">&times;</span>
			</button>
		</div>
	</div>

	<div class="table-responsive position-relative tpl3pl-table-wrapper">
		<div *ngIf="loading" class="tpl3pl-loading-overlay">
			<mat-spinner diameter="48"></mat-spinner>
			<p class="mt-2 mb-0">Loading orders…</p>
		</div>
		<div *ngIf="processing && !loading" class="tpl3pl-loading-overlay">
			<mat-spinner diameter="48"></mat-spinner>
			<p class="mt-2 mb-0">Processing queue…</p>
		</div>
		<div *ngIf="batchDeleting && !loading && !processing" class="tpl3pl-loading-overlay">
			<mat-spinner diameter="48"></mat-spinner>
			<p class="mt-2 mb-0">Removing selected rows…</p>
		</div>
		<table mat-table [dataSource]="dataSource" class="w-100" matSort [class.tpl3pl-loading-opacity]="loading || processing || batchDeleting">
			<ng-container matColumnDef="select">
				<th mat-header-cell *matHeaderCellDef class="tpl3pl-select-col">
					<mat-checkbox
						(change)="onMasterCheckboxChange($event.checked)"
						[checked]="isAllCheckboxRowsSelected()"
						[indeterminate]="isCheckboxRowsSelectionIndeterminate()"
						[disabled]="loading || processing || rawPushInProgress || batchDeleting || getCheckboxSelectableLoadedRows().length === 0"
						matTooltip="Select or clear all rows you can export (pending/failed) or remove (pending/failed/dead letter)">
					</mat-checkbox>
				</th>
				<td mat-cell *matCellDef="let item" class="tpl3pl-select-col">
					<mat-checkbox
						(click)="$event.stopPropagation()"
						(change)="setRowCheckboxSelected(item, $event.checked)"
						[checked]="selection.isSelected(item)"
						[disabled]="!isRowCheckboxSelectable(item) || loading || processing || rawPushInProgress || batchDeleting || !!exportingOrderNo"
						matTooltip="Export: pending/failed. Remove: pending/failed/dead letter.">
					</mat-checkbox>
				</td>
			</ng-container>
			<ng-container matColumnDef="orderno">
				<th mat-header-cell *matHeaderCellDef mat-sort-header>Order Number</th>
				<td mat-cell *matCellDef="let item">
					<span class="order-link" (click)="viewOrder(item.orderno)">{{ item.orderno }}</span>
				</td>
			</ng-container>

		<ng-container matColumnDef="debtorno">
			<th mat-header-cell *matHeaderCellDef>Debtor #</th>
			<td mat-cell *matCellDef="let item">
				<span *ngIf="item.debtorno" class="text-monospace">{{ item.debtorno }}<span *ngIf="item.branchcode">/{{ item.branchcode }}</span></span>
				<span *ngIf="!item.debtorno" class="text-muted">—</span>
			</td>
		</ng-container>

		<ng-container matColumnDef="customer_name">
			<th mat-header-cell *matHeaderCellDef>Name</th>
			<td mat-cell *matCellDef="let item">
				<span *ngIf="item.customer_name" class="small">{{ item.customer_name }}</span>
				<span *ngIf="!item.customer_name" class="text-muted">—</span>
			</td>
		</ng-container>

		<ng-container matColumnDef="payterms">
			<th mat-header-cell *matHeaderCellDef matTooltip="Payment terms code from the order">Terms</th>
			<td mat-cell *matCellDef="let item">
				<span *ngIf="item.payterms" class="text-monospace small">{{ item.payterms }}</span>
				<span *ngIf="!item.payterms" class="text-muted">—</span>
			</td>
		</ng-container>

		<ng-container matColumnDef="tpl3pl_remote_order_id">
			<th mat-header-cell *matHeaderCellDef matTooltip="3PL/PGS order ID from their system">3PL Order ID</th>
				<td mat-cell *matCellDef="let item">
					<span *ngIf="item.tpl3pl_remote_order_id" class="text-monospace">{{ item.tpl3pl_remote_order_id }}</span>
					<span *ngIf="!item.tpl3pl_remote_order_id" class="text-muted">—</span>
				</td>
			</ng-container>

			<ng-container matColumnDef="export_status">
				<th mat-header-cell *matHeaderCellDef mat-sort-header class="status-header-cell">Status</th>
				<td mat-cell *matCellDef="let item" class="status-column-cell">
					<div class="status-cell">
						<span [ngClass]="getStatusBadgeClass(item.export_status)" class="badge">
							{{ getStatusLabel(item.export_status) }}
						</span>
						<span *ngIf="item.archived_at" class="badge badge-secondary ml-1">Archived</span>
						<span *ngIf="item.export_status === 'exported' && item.exported_at" class="status-completed">{{ item.exported_at | date:'short' }}</span>
					</div>
				</td>
			</ng-container>

	<ng-container matColumnDef="state">
		<th mat-header-cell *matHeaderCellDef matTooltip="Internal queue state / live PGS status">State</th>
		<td mat-cell *matCellDef="let item">
			<span *ngIf="item.state" [ngClass]="getStateBadgeClass(item.state)">{{ item.state }}</span>
			<span *ngIf="!item.state" class="text-muted">—</span>
			<ng-container *ngIf="{ l: getPgsStatusLabel(item), ca: item.pgs_status_checked_at } as pgs">
				<div *ngIf="pgs.l || pgs.ca" class="small text-muted mt-1"
					[matTooltip]="'PGS: ' + (pgs.l || '—') + (pgs.ca ? (' · checked ' + (pgs.ca | date:'short')) : '')">
					<ng-container *ngIf="pgs.l">PGS: {{ pgs.l }}</ng-container>
					<ng-container *ngIf="!pgs.l && pgs.ca">PGS: last checked {{ pgs.ca | date:'short' }}</ng-container>
				</div>
			</ng-container>
		</td>
	</ng-container>

		<ng-container matColumnDef="erp_status">
			<th mat-header-cell *matHeaderCellDef matTooltip="ERP order status from salesorders">ERP Status</th>
			<td mat-cell *matCellDef="let item">
				<div class="d-flex align-items-center flex-wrap erp-status-cell">
					<span
						*ngIf="item.erp_order_status_name || item.erp_order_status_id"
						class="erp-status-pill"
						[ngClass]="getErpStatusClass(item.erp_order_status_id)"
						[attr.title]="'Status ID: ' + item.erp_order_status_id">
						{{ item.erp_order_status_name || item.erp_order_status_id }}
					</span>
					<span *ngIf="!item.erp_order_status_name && !item.erp_order_status_id" class="text-muted">—</span>
					<button
						mat-icon-button
						type="button"
						class="erp-status-force-btn"
						(click)="openForceErpStatusDialog(item); $event.stopPropagation()"
						[disabled]="loading || processing || batchDeleting || !!exportingOrderNo"
						matTooltip="Force ERP status (direct update; e.g. set Dispatched when 3PL shipped but ERP still Pending)">
						<mat-icon>edit</mat-icon>
					</button>
				</div>
			</td>
		</ng-container>

		<ng-container matColumnDef="erp_fillability">
			<th mat-header-cell *matHeaderCellDef matTooltip="Fillability based on current open order lines and warehouse stock">Fillability</th>
			<td mat-cell *matCellDef="let item">
				<span
					*ngIf="item.erp_fillability && item.erp_fillability !== 'unknown'"
					class="erp-fill-pill"
					[ngClass]="getFillabilityClass(item.erp_fillability)">
					{{ item.erp_fillability_label || item.erp_fillability }}
				</span>
				<span *ngIf="!item.erp_fillability || item.erp_fillability === 'unknown'" class="text-muted">—</span>
			</td>
		</ng-container>

		<ng-container matColumnDef="placedby">
		<th mat-header-cell *matHeaderCellDef matTooltip="Who placed the order">Placed By</th>
		<td mat-cell *matCellDef="let item">
			<span *ngIf="item.placedby" class="small">{{ item.placedby }}</span>
			<span *ngIf="!item.placedby" class="text-muted">—</span>
		</td>
	</ng-container>

	<ng-container matColumnDef="enteredby">
		<th mat-header-cell *matHeaderCellDef matTooltip="Who entered the order">Entered By</th>
		<td mat-cell *matCellDef="let item">
			<span *ngIf="item.enteredby" class="small">{{ item.enteredby }}</span>
			<span *ngIf="!item.enteredby" class="text-muted">—</span>
		</td>
	</ng-container>

	<ng-container matColumnDef="created_at">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Recorded</th>
			<td mat-cell *matCellDef="let item">{{ item.created_at | date:'short' }}</td>
		</ng-container>

			<ng-container matColumnDef="export_attempts">
				<th mat-header-cell *matHeaderCellDef>Attempts</th>
				<td mat-cell *matCellDef="let item">{{ item.export_attempts }}</td>
			</ng-container>

			<ng-container matColumnDef="last_export_attempt">
				<th mat-header-cell *matHeaderCellDef mat-sort-header>Last attempt</th>
				<td mat-cell *matCellDef="let item">{{ item.last_export_attempt | date:'short' }}</td>
			</ng-container>

			<ng-container matColumnDef="error_message">
				<th mat-header-cell *matHeaderCellDef>Error</th>
				<td mat-cell *matCellDef="let item" class="error-cell">
					<span
						*ngIf="(item.error_message || item.export_response?.circuit_open) && item.export_status !== 'exported'"
						class="error-summary"
						(click)="openErrorDetails(item)"
						[attr.title]="item.error_message || 'View details'">
						{{ getErrorSummary(item) }}
					</span>
					<span *ngIf="(!item.error_message && !item.export_response?.circuit_open) || item.export_status === 'exported'" class="text-muted">—</span>
				</td>
			</ng-container>

			<ng-container matColumnDef="actions">
				<th mat-header-cell *matHeaderCellDef>Actions</th>
				<td mat-cell *matCellDef="let item">
					<div class="actions-cell">
						<mat-spinner *ngIf="exportingOrderNo === item.orderno" diameter="24" class="action-spinner"></mat-spinner>
						<button
							mat-icon-button
							color="primary"
							(click)="retryExport(item)"
							*ngIf="canRetry(item) && exportingOrderNo !== item.orderno"
							[disabled]="processing || loading || exportingOrderNo"
							matTooltip="Retry export">
							<mat-icon>refresh</mat-icon>
						</button>
						<button
							mat-icon-button
							color="accent"
							(click)="exportOrder(item.orderno)"
							*ngIf="item.export_status === 'pending' && exportingOrderNo !== item.orderno"
							[disabled]="processing || loading || exportingOrderNo"
							matTooltip="Export now">
							<mat-icon>send</mat-icon>
						</button>
						<button
							mat-icon-button
							color="primary"
							(click)="viewLogs(item)"
							*ngIf="item.export_status === 'failed' || item.export_status === 'dead_letter'"
							matTooltip="View logs">
							<mat-icon>article</mat-icon>
						</button>
						<button
							mat-icon-button
							color="primary"
							(click)="viewShipments(item)"
							*ngIf="item.export_status === 'exported'"
							matTooltip="View shipments">
							<mat-icon>local_shipping</mat-icon>
						</button>
					<button
						mat-icon-button
						color="accent"
						(click)="forceResendExported(item)"
						*ngIf="item.export_status === 'exported' && exportingOrderNo !== item.orderno"
						[disabled]="processing || loading || exportingOrderNo"
						matTooltip="Re-send to 3PL (warehouse removed order)">
						<mat-icon>published_with_changes</mat-icon>
					</button>
					<button
						mat-icon-button
						color="warn"
						(click)="cancelOrder(item)"
						*ngIf="item.export_status === 'exported' && item.state !== 'Cancelled' && exportingOrderNo !== item.orderno"
						[disabled]="processing || loading || exportingOrderNo"
						matTooltip="Cancel at 3PL — only works while order is still open (not picked/shipped)">
						<mat-icon>cancel</mat-icon>
					</button>
						<button
							mat-icon-button
							color="accent"
							(click)="openResponseDetails(item)"
							[disabled]="previewLoadingOrderNo === item.orderno"
							matTooltip="View raw request / response">
							<mat-spinner *ngIf="previewLoadingOrderNo === item.orderno" diameter="20"></mat-spinner>
							<mat-icon *ngIf="previewLoadingOrderNo !== item.orderno">code</mat-icon>
						</button>
				<button
					mat-icon-button
					color="primary"
					(click)="checkPgsStatus(item)"
					*ngIf="item.export_status === 'exported'"
					matTooltip="Check live status at PGS">
					<mat-icon>track_changes</mat-icon>
				</button>
					<button
						mat-icon-button
						(click)="archiveQueueItem(item)"
						*ngIf="item.export_status === 'exported' && !item.archived_at"
						matTooltip="Archive (hide from list)">
						<mat-icon>archive</mat-icon>
					</button>
					<button
						mat-icon-button
						color="accent"
						(click)="unarchiveQueueItem(item)"
						*ngIf="item.archived_at"
						matTooltip="Unarchive — restore to exported state">
						<mat-icon>unarchive</mat-icon>
					</button>
						<button
							mat-icon-button
							color="warn"
							(click)="deleteQueueItem(item)"
							*ngIf="item.export_status === 'failed' || item.export_status === 'pending' || item.export_status === 'dead_letter'"
							[disabled]="processing || loading || exportingOrderNo || batchDeleting"
							matTooltip="Remove from queue">
							<mat-icon>delete_outline</mat-icon>
						</button>
					</div>
				</td>
			</ng-container>

			<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
			<tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
			<tr class="mat-row" *matNoDataRow>
				<td class="mat-cell text-center text-muted py-4" [attr.colspan]="displayedColumns.length">No orders in the export queue.</td>
			</tr>
		</table>

		<mat-paginator [pageSize]="50" [pageSizeOptions]="[50, 100, 25, 10]"></mat-paginator>
	</div>

	<div *ngIf="selectedErrorDetails" class="mt-3 error-details-card">
		<div class="d-flex justify-content-between align-items-start">
			<div class="flex-grow-1">
				<div class="alert alert-warning mb-1" *ngIf="selectedErrorDetails.circuitOpen">
					<strong>Circuit breaker open.</strong> The request was not sent to the 3PL. No raw response from their API.
				</div>
				<div class="alert alert-danger mb-1">
					<strong>Error for order {{ selectedErrorItem?.orderno }}:</strong>
					<span *ngIf="selectedErrorDetails.errorCode" class="ml-2 text-monospace">({{ selectedErrorDetails.errorCode }})</span>
					<pre *ngIf="!selectedErrorDetails.circuitOpen && selectedErrorDetails.message" class="error-full-message mb-0 mt-1">{{ selectedErrorDetails.message }}</pre>
					<span *ngIf="selectedErrorDetails.circuitOpen || (!selectedErrorDetails.message && !selectedErrorDetails.errorCode)">{{ selectedErrorDetails.circuitOpen ? 'Request blocked by circuit breaker.' : 'No message.' }}</span>
				</div>
				<div class="small text-muted mb-1">
					<span *ngIf="selectedErrorDetails.canRetry">This error can be retried.</span>
					<span *ngIf="!selectedErrorDetails.canRetry">This error appears unrecoverable. Fix the order or configuration before retrying.</span>
				</div>
				<div class="d-flex align-items-center flex-wrap mt-1 mb-1">
					<button *ngIf="selectedErrorItem && canRetry(selectedErrorItem)" mat-stroked-button color="primary" class="mr-2" (click)="retryExport(selectedErrorItem); clearErrorDetails()">
						<mat-icon>refresh</mat-icon> Retry Export
					</button>
					<button *ngIf="selectedErrorItem?.export_response" mat-stroked-button (click)="openResponseDetails(selectedErrorItem); clearErrorDetails()">
						<mat-icon>code</mat-icon> View raw response
					</button>
				</div>
				<div *ngIf="selectedErrorDetails.response" class="mt-1">
					<strong>Last 3PL response:</strong>
					<pre class="mb-0 p-2 bg-light small error-details-pre">{{ selectedErrorDetails.response | json }}</pre>
				</div>
			</div>
			<button type="button" class="close ml-2" aria-label="Close" (click)="clearErrorDetails()">
				<span aria-hidden="true">&times;</span>
			</button>
		</div>
	</div>

</div>
